import { useState, useEffect } from 'react';

let isScriptLoading = false;
let isScriptLoaded = false;

export const useJessibuca = () => {
  const [loaded, setLoaded] = useState(
    typeof window !== 'undefined' && !!window.Jessibuca
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (window.Jessibuca) {
      setLoaded(true);
      return;
    }

    if (isScriptLoaded) {
      setLoaded(true);
      return;
    }

    if (isScriptLoading) {
      const interval = setInterval(() => {
        if (window.Jessibuca) {
          setLoaded(true);
          isScriptLoaded = true;
          isScriptLoading = false;
          clearInterval(interval);
        }
      }, 100);
      return () => clearInterval(interval);
    }

    isScriptLoading = true;
    const script = document.createElement('script');
    script.src = '/jessibuca/jessibuca.js';
    script.async = true;

    script.onload = () => {
      isScriptLoaded = true;
      isScriptLoading = false;
      setLoaded(true);
    };

    script.onerror = () => {
      isScriptLoading = false;
      console.error('Failed to load Jessibuca script');
    };

    document.head.appendChild(script);
  }, []);

  return loaded;
};
